import React, { memo, useEffect, useMemo, useRef, useState } from 'react';
import styled from '@emotion/styled';
import { fontWeight, spacing, zIndex } from 'presentations/views/styles';
import { imagePath } from 'presentations/assets';

interface Props {
  isLocalPerson: boolean;
  style?: any;
  name: string;
  color: string;
}

const Component = memo((props: Props) => {
  let top = props.style.top;
  const maxBottom = window.innerHeight - 65 - 112;
  if (maxBottom < props.style.top) {
    top = maxBottom;
  }
  let left = props.style.left;
  const maxRight = window.innerWidth - 112;
  if (maxRight < props.style.left) {
    left = maxRight;
  }
  const style = {
    ...props.style,
    top,
    left,
  };

  return (
    <UserContainer style={style}>
      {!props.isLocalPerson && (
        <>
          <Pointer>
            <PointerImage color={props.color} />
          </Pointer>
          <NamePlate color={props.color}>{props.name}</NamePlate>
        </>
      )}
    </UserContainer>
  );
});

const UserContainer = styled.div`
  position: absolute;
  z-index: ${zIndex(1400)};
`;
const User = styled.div<{ color: string }>`
  position: absolute;
  top: 12px;
  left: 12px;
  width: 112px;
  height: 112px;
  background-color: #ccc;
  color: white;
  border-radius: 50%;
  border: ${(props) => `4px solid ${props.color}`};
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
`;
const Pointer = styled.div`
  position: absolute;
  top: 0px;
  left: 0px;
  mask-image: url(${imagePath('pages/event/icon_arrow.png')});
  transform: rotate(-45deg);
`;
const PointerImage = styled.div<{ color: string }>`
  mask: no-repeat center/70%;
  -webkit-mask: no-repeat center/70%;
  background: ${(props) => props.color};
  width: 16px;
  height: 20px;
`;

const NamePlate = styled.div<{ color: string }>`
  background-color: ${(props) => props.color};
  position: absolute;
  display: flex;
  align-items: center;
  height: 46px;
  font-weight: ${fontWeight('bold')};
  top: 12px;
  left: 12px;
  background-color: ${(props) => props.color};
  color: white;
  border-radius: 23px;
  padding: 0 ${spacing(16)};
  white-space: nowrap;
`;

export default Component;
